const envalues = process.env;

export default {
    apiServerUrl: envalues.NEXT_PUBLIC_API_URL,
    appDomainUrl: envalues.NEXT_PUBLIC_APP_URL,
};
